import { ReactNode, useMemo } from 'react';
import { SWRConfig } from 'swr';

import { createRestClient } from '../restClient';

type RestConfigProviderProps = {
  children: ReactNode;
};

export function RestConfigProvider({
  children,
}: RestConfigProviderProps): JSX.Element {
  const restClient = useMemo(() => createRestClient(), []);

  return <SWRConfig value={{ fetcher: restClient }}>{children} </SWRConfig>;
}
